export default "__VITE_ASSET__CXtqj3b2__"